import React from 'react';

const page404 = () => {
  return (
    <section className="hero is-success is-medium">
      <div className="hero-body">
        <div className="container">
        <h1 className="title">
          <i className='fas fa-grin-squint-tears'></i> 404 Not Found
        </h1>
        <h2 className="subtitle">
          I wonder how you got here.
        </h2>
        </div>
      </div>
    </section>
  );
}

export default page404;
